<template>
  <v-list-item @click="select()">
    <v-list-item-action class="my-1">
      <h-avatar :resource="item" />
    </v-list-item-action>
    <v-list-item-content>
      <v-list-item-title v-text="item.name" />
    </v-list-item-content>
    <v-list-item-action-text>
      {{ combination.price | currency | hideZero }}
    </v-list-item-action-text>
  </v-list-item>
</template>

<script>
  import Currenciable from '@/Mixins/Currenciable'
  import HAvatar from '@/Components/Avatar'

  export default {
    mixins: [
      Currenciable,
    ],

    components: {
      HAvatar,
    },

    props: {
      combination: {
        required: true,
        type: Object,
      },
    },

    computed: {
      item () {
        return this.$store.getters['catalog/item'](this.combination.menu_item_id)
      },
    },

    methods: {
      select () {
        this.$emit('select', {
          itemName: this.item.name,
          price: this.combination.price,
          combination_id: this.combination.id,
        })
      },
    },
  }
</script>
